module.exports = __webpack_public_path__ + "static/media/entregarinju2.7e5e7e5a.webp";